import { api } from "@/builders/axios";
import {
  CourseData,
  CourseList,
  CreateCourseData,
} from "@/builders/types/course";
import { FilterParams } from "@/builders/types/filter-params";
import { TopRatedLearning } from "@/builders/types/top-rated";

import { id } from "./id";
import { modules } from "./module";
import { others } from "./others";
import { wishlist } from "./wishlist";

export type RatingsData = {
  [key: string]: number;
};

const list = function (
  params?: FilterParams<{
    department?: number | string;
    group?: number | string;
  }>
) {
  return api.get<CourseList>("courses", { params }).then(({ data }) => data);
};

const post = function (data: CreateCourseData) {
  return api
    .post<{
      data: CourseData;
    }>("/courses", data)
    .then(({ data }) => data);
};

const top_rated = function (params?: FilterParams) {
  return api.get<TopRatedLearning>("/courses/others/top-rated", { params });
};

const ratings = function (id: number) {
  return api.get<RatingsData>(`courses/${id}/rating`);
};

export const courses = {
  list,
  post,
  id,
  modules,
  others,
  top_rated,
  wishlist,
  ratings,
};
